import { AppState } from '../root.reducer';

export const getRepositOfferById = (id: string) => (state: AppState) => state.entities.repositOffer[id];

export const getIsResponseModalOpen = (state: AppState) => state.repositOffer.isResponseModalOpen;
